import { createImageProxy, ImageProxyVendor, Stage } from '@efishery/sdk-core';
import { ENV } from 'config/env';

const env = ENV.APP_ENVIRONMENT as Stage;

export const proxy = createImageProxy({
  env: env,
  vendor: ImageProxyVendor.ImageService,
});
